import axios from "axios"
import { API_URL } from "../config"


export const unauthorizedApi = axios.create({
    baseURL: API_URL,
  })

